import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { OrganisationState } from './types';

const selectCache = (state: RootState) => state.organisationCache;

export const currentUserOrganisation = createSelector(
  selectCache,
  (cache: OrganisationState) => cache.currentUserOrganisation
);
